import { Injectable } from '@angular/core';
import { ValidatorFn, Validators } from '@angular/forms';
import { QuestionType } from '../models/question/question-type.model';
import { Question } from '../models/question/question.model';
import {
  MaxLengthNumber,
  MaxLengthTable,
  ValidateEmail,
  ValidateIsValidDiaryNumber,
  ValidateIsValidPhoneNumber,
  ValidateSpace,
  ValidateWebpage,
} from '@vinnova/validation';
import { QuestionStructureInput } from '../models/question/question-input.model';

@Injectable({
  providedIn: 'root',
})
export class ValidationMapperService {
  getValueValidation(question: Question): ValidatorFn[] {
    if (!question?.validation) {
      return undefined;
    }
    return this.getValidators(question);
  }

  getValidators(question: Question): ValidatorFn[] {
    const validators = [];

    if (question.validation.required) {
      validators.push(Validators.required, ValidateSpace);
    }
    if (question.validation.maxLength) {
      if (this.isNumber(question)) {
        validators.push(MaxLengthNumber(question.validation.maxLength));
      } else if (question.type === QuestionType.InputTable) {
        validators.push(MaxLengthTable(question.validation.maxLength));
      } else {
        validators.push(Validators.maxLength(question.validation.maxLength));
      }
    }
    if (question.validation.minLength) {
      validators.push(Validators.minLength(question.validation.minLength));
    }
    if (question.validation.pattern) {
      validators.push(Validators.pattern(question.validation.pattern));
    }
    if (question.validation.isEmail) {
      validators.push(ValidateEmail);
    }
    if (question.validation.isWebpage) {
      validators.push(ValidateWebpage);
    }
    if (question.validation.isPhone) {
      validators.push(ValidateIsValidPhoneNumber);
    }
    if (question.validation.isDiarynumber) {
      validators.push(ValidateIsValidDiaryNumber);
    }

    return validators;
  }

  private isNumber(question: Question) {
    if (question.type === QuestionType.Input) {
      const structure = question.structure as QuestionStructureInput;
      if (
        structure.inputType === 'isNumber' ||
        structure.inputType === 'isAmount' ||
        structure.inputType === 'isPercent'
      ) {
        return true;
      }
    }
    return false;
  }
}
